/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Partner_Admin_Invoice_Status_PaidInputs */



/**
* | output |
* | --- |
* | "Paid" |
*
* @param {Partner_Admin_Invoice_Status_PaidInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const partner_admin_invoice_status_paid = /** @type {((inputs?: Partner_Admin_Invoice_Status_PaidInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Partner_Admin_Invoice_Status_PaidInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return /** @type {LocalizedString} */ ("Bezahlt")
	return /** @type {LocalizedString} */ ("Paid")
});